import getCookie from '../utils/getCookies';
import { apiforFlow } from './api';

export type OpcaoLabelValue = {
  readonly label: string;
  readonly value: string | number;
};

type MunicipioWebhook = {
  readonly id: number;
  readonly nome: string;
};

type InstituicaoWebhook = {
  readonly id: number;
  readonly nome: string;
  readonly codigoIE?: string;
  readonly cidade?: string;
};

type ModalidadeWebhook = {
  readonly nome: string;
};

const obterToken = (): string => getCookie('gov_access_token_sso') || '';

/**
 * Lista municípios via proxy do FormFlow.
 */
export const listarMunicipios = async (): Promise<OpcaoLabelValue[]> => {
  const response = await apiforFlow.get('/flow/ensino/municipios/', {
    headers: {
      Authorization: `Bearer ${obterToken()}`,
    },
  });
  const data = (response.data || []) as MunicipioWebhook[];
  return data.map((item) => ({
    label: item.nome,
    value: item.id,
  }));
};

/**
 * Lista instituições de ensino filtradas pelo nome do município.
 */
export const listarInstituicoes = async (
  municipioNome: string,
): Promise<OpcaoLabelValue[]> => {
  const response = await apiforFlow.get('/flow/ensino/instituicoes-de-ensino/', {
    params: { municipio: municipioNome },
    headers: {
      Authorization: `Bearer ${obterToken()}`,
    },
  });
  const data = (response.data || []) as InstituicaoWebhook[];
  return data.map((item) => ({
    label: item.nome,
    value: item.id,
  }));
};

/**
 * Lista modalidades filtradas pelo id da instituição.
 */
export const listarModalidades = async (
  instituicaoId: string | number,
): Promise<OpcaoLabelValue[]> => {
  const response = await apiforFlow.get(
    '/flow/ensino/instituicoes-de-ensino/modalidades/',
    {
      params: { instituicaoId },
      headers: {
        Authorization: `Bearer ${obterToken()}`,
      },
    },
  );
  const data = (response.data || []) as ModalidadeWebhook[];
  return data.map((item) => ({
    label: item.nome,
    value: item.nome,
  }));
};
